import { Plugin } from '@tiptap/pm/state';
import { Extension } from '@tiptap/react';

/**
 * Marks the root of a read-only editor `aria-readonly`. Tiptap gives every editor root `role="textbox"`, and
 * WAI-ARIA requires a textbox that cannot be edited to say so; without it, screen readers announce read-only
 * text as an editable field. Reads `options.editable` rather than `isEditable`, which is false until the view
 * exists, and is re-evaluated when `setEditable` changes it.
 */
export const ReadOnlyAria = Extension.create({
  name: 'readOnlyAria',

  addProseMirrorPlugins() {
    const { editor } = this;
    return [
      new Plugin({
        props: {
          attributes: (): Record<string, string> => (editor.options.editable ? {} : { 'aria-readonly': 'true' })
        }
      })
    ];
  }
});
